import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import { path_url } from "../../Config/config";
import clipboardImage from "../../Images/clipboard_10.png";
import { getToken, getAuthHeader, removeToken } from "../../Utils/auth";

export default function ExpenseDashboard() {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [expenseList, setExpenseList] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  useEffect(() => {
    const token = getToken();
    if (token) {
      fetchExpenses();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Per Swagger: the Expense module only exposes GET /expense/all
  // (no /expense/dashboard/{useradminid} like Task/Customer/Vendor).
  // It also does not filter by admin server-side, so we filter
  // client-side against the logged-in adminId.
  const fetchExpenses = async () => {
    try {
      const adminId = localStorage.getItem("adminId");

      const response = await axios.get(`${path_url}/expense/all`, {
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
      });

      // Handle multiple possible response shapes from the backend:
      //  1. response.data.body  → array of expenses
      //  2. response.data.body.expenseList → array
      //  3. response.data → array directly
      const raw = response.data;
      let list = [];

      if (Array.isArray(raw)) {
        list = raw;
      } else if (Array.isArray(raw?.body)) {
        list = raw.body;
      } else if (Array.isArray(raw?.body?.expenseList)) {
        list = raw.body.expenseList;
      } else if (Array.isArray(raw?.expenseList)) {
        list = raw.expenseList;
      }

      // Filter by adminId — compare as lowercase trimmed strings to avoid
      // UUID casing or whitespace mismatches.
      const normalizedAdminId = adminId ? adminId.toLowerCase().trim() : null;
      const filtered = normalizedAdminId
        ? list.filter(
            (exp) =>
              exp.useradminid &&
              exp.useradminid.toLowerCase().trim() === normalizedAdminId
          )
        : list;

      setExpenseList(filtered);
      setLoading(false);
    } catch (error) {
      console.warn("Error fetching expense list:", error);
      if (error.response && error.response.status === 401) {
        removeToken();
        navigate("/login");
        return;
      }
      setExpenseList([]);
      setLoading(false);
    }
  };


  const handleNewExpense = () => {
    navigate("/new-expense");
  };

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />

        <div className="greet">
          <div
            className="bg-white rounded mt-2 d-flex align-items-center subcon3 p-2"
            style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
          >
            <div className="col-sm-8 mt-2 ml-2 mb-2">
              <strong>Expense Dashboard</strong>
              <div className="mt-2">All created expenses are listed below.</div>
            </div>
            <div className="col-4 d-flex justify-content-end pr-4">
              <button onClick={handleNewExpense} className="btn btn-primary">
                + New Expense
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center p-5">Loading...</div>
        ) : expenseList.length === 0 ? (
          <div className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
            <img
              src={clipboardImage}
              alt="No Data"
              className="mb-3"
              style={{ width: "80px" }}
            />
            <div className="text-muted mb-3">
              <span>No expenses found.</span>
            </div>
            <button onClick={handleNewExpense} className="btn btn-primary">
              Create Expense
            </button>
          </div>
        ) : (
          <div className="col-12 d-flex justify-content-center mt-2">
            <div
              className="col-12 border rounded"
              style={{
                padding: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                background: "white",
                overflowX: "auto",
              }}
            >
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Bill Number</th>
                    <th>Subject</th>
                    <th>Category</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Approval Status</th>
                  </tr>
                </thead>
                <tbody>
                  {expenseList.map((exp) => (
                    <tr key={exp.id}>
                      <td>{exp.billnumber}</td>
                      <td>{exp.subject}</td>
                      <td>{exp.category}</td>
                      <td>{exp.expensedate}</td>
                      <td>{exp.expenseamount}</td>
                      <td>{exp.status}</td>
                      <td>{exp.approvalstatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <UserFooter />
      </div>
    </div>
  );
}